module.exports = __webpack_public_path__ + "static/media/tma-logo-blue.b072fbf0.png";